/* 孫吳傳・第 10 章：江夏斬黃祖（建安十三年，208）
 * 史實：《三國志·董襲傳》黃祖「橫兩蒙衝挾守沔口，以栟閭大紲繫石爲矴，上有千人，以弩交射，飛矢雨下，軍不得前。」
 *       董襲與凌統各領敢死百人，「人被兩鎧，乘大舸船，突入蒙衝裏。襲身以刀斷兩紲，蒙衝乃橫流，大兵遂進。」
 *       《吳主傳》：「祖挺身亡走，騎士馮則追梟其首。」
 * 流程：操作凌統，船上載著董襲。冒著蒙衝上的弩箭（先預告）把船划到大纜旁停住，董襲砍纜（船一動就要重來）；
 *       黃祖的小船會靠過來接舷 → 兩條大纜都斷了，蒙衝橫流，江口打開 → 從碼頭登岸，追斬想逃的黃祖。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS, PEOPLE, rout, vanish } from '../kit.ts';
import { BLOCK_X, ROPES, DOCK, ZU, EXIT } from '../maps/mianku.ts';

const LV = 10, START = [900, 2550], CUT_D = 290; // 砍纜的位置：江口路障西邊 290
const FOE = { spec: TROOPS.huangzu, name: '黃祖兵' };
const landOk = (x, y) => SG.gd(x, y, DOCK[0], DOCK[1]) < 420;

export default {
  id: 'sunwu-10', map: 'mianku', hero: 'lingtong',
  title: '第 9 章　江夏斬黃祖', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '橫兩蒙衝挾守沔口，以栟閭大紲繫石爲矴，上有千人，以弩交射，飛矢雨下，軍不得前。', src: '《三國志·吳書·董襲傳》' }],
    text: '孫權西征江夏太守黃祖，為父親孫堅報仇。黃祖用兩艘蒙衝橫鎖沔口，船上千人以弩交射。董襲與凌統各領敢死百人，乘大舸突入。',
    goals: ['掩護董襲砍斷兩條大纜', '從碼頭登岸', '追斬黃祖'],
  },
  words: { ally: '敢死士', foe: '黃祖兵' },
  stars: [
    { text: '董襲沒有倒下', ok: (m) => !m.vars.dxDown },
    { text: '親手追上黃祖（不讓他逃出營外）', ok: (m) => !!m.vars.caught },
    { text: '砍纜時船沒被逼開超過 2 次', ok: (m) => (m.vars.broke || 0) <= 2 },
  ],
  steps: [
    { // 1. 突入蒙衝：砍兩條大纜
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        const dx = ally(w, PEOPLE.dongxi, START[0], START[1], LV); dx.name = '董襲'; V.dx = dx;
        const men = Array.from({ length: 3 }, () => m.recruit(START[0], START[1], '敢死士'));
        V.b = m.boat(me, { x: START[0], y: START[1], sp: 190, crew: [dx, ...men], land: true, landOk, flag: '#c0302a', big: false });
        // 兩艘蒙衝（大船），船上有黃祖兵；江口用一排路障擋住
        V.ships = [[BLOCK_X + 60, 2320], [BLOCK_X + 60, 2760]].map(([x, y]) => {
          const cap = m.foe('bandit', x, y, Object.assign({}, FOE, { name: '蒙衝守將' })), crew = Array.from({ length: 3 }, () => m.foe('huangjin', x, y, FOE));
          return m.boat(cap, { x, y, crew, big: true, flag: '#3e5a5a', col: '#4a3a28' });
        });
        for (let i = 0; i < 7; i++) m.gate('mc' + i, BLOCK_X, 1850 + i * 230, 230);
        V.cut = [false, false];
        ROPES.forEach(([x, y], i) => m.mark('r' + i, x - CUT_D, y, '大纜', true));
        m.card('飛矢雨下，軍不得前。', '《董襲傳》');
        m.after(2, () => m.line('董襲', '公績，把船靠到大纜邊停住，我來砍！'));
        m.after(5, () => m.line('提示', '你在船上：右鍵點江面划船。靠到「大纜」旁停住，董襲才能砍；船一動就要重來。'));
        m.obj('cut', '掩護董襲砍斷兩條大纜', 2);
        V.small = [];
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, b = V.b, dx = V.dx;
        // 蒙衝上的弩箭：船進到 1100 內就射
        V.volT = (V.volT || 0) - dt;
        if (V.volT <= 0 && b.x > BLOCK_X - 1100) { V.volT = 1.1; m.strike(b.x + (SG.rand() - 0.5) * 220, b.y + (SG.rand() - 0.5) * 140, 115, 1.1, 50, 0); }
        // 黃祖的小船：每 14 秒一艘，靠過來接舷
        V.smallT = (V.smallT || 6) - dt;
        if (V.smallT <= 0) {
          V.smallT = 14;
          const y = SG.rand() < 0.5 ? 1950 : 3150, cap = m.foe('huangjin', BLOCK_X - 330, y, FOE), crew = [m.foe('huangjin', BLOCK_X - 330, y, FOE)];
          const sb = m.boat(cap, { x: BLOCK_X - 330, y, crew, small: true, sp: 200, flag: '#3e5a5a' });
          V.small.push(sb);
        }
        for (const sb of V.small) if (sb.u.alive) { const d = SG.gd(sb.x, sb.y, b.x, b.y); sb.goal = d > 110 ? [b.x + (sb.x < b.x ? -100 : 100), b.y + (sb.y < b.y ? -40 : 40)] : null; }
        // 砍纜：船停在大纜旁
        ROPES.forEach(([x, y], i) => {
          if (V.cut[i] || dx.chan || !dx.alive) return;
          if (SG.gd(b.x, b.y, x - CUT_D, y) < 170 && b.still > 0.3) m.chan(dx, 4, '斷紲', () => {
            V.cut[i] = true; m.prog('cut', V.cut.filter(Boolean).length); m.unmark('r' + i);
            w.fx({ k: 'spark', x, y, col: '#ffe0a0' });
            m.line('董襲', i === 0 && !V.cut[1] ? '斷了一條！還有一條！' : '兩條都斷了！');
          }, { hurt: false, fail: () => { V.broke = (V.broke || 0) + 1; } });
        });
        if (!dx.alive) V.dxDown = true;
        return V.cut[0] && V.cut[1];
      },
    },
    { // 2. 蒙衝橫流：登岸
      enter(m, w) {
        const V = m.vars;
        m.done('cut');
        m.card('襲身以刀斷兩紲，蒙衝乃橫流，大兵遂進。', '《董襲傳》');
        for (let i = 0; i < 7; i++) m.ungate('mc' + i);
        V.ships.forEach((s, i) => { s.goal = [s.x + 1600, s.y + (i ? 350 : -250)]; s.sp = 70; });
        m.after(14, () => V.ships.forEach((s) => { for (const u of [s.u, ...s.crew]) if (u.alive) { u.alive = false; u.counted = true; } m.unboat(s); }));
        rout(m, w, V.small.flatMap((s) => [s.u, ...s.crew]).filter((u) => u.alive), [8000, 2500]);
        m.mark('dock', DOCK[0], DOCK[1], '碼頭');
        m.obj('dock', '從北岸的碼頭登岸');
      },
      tick(m, w) { return !w.player.boat; },
    },
    { // 3. 追斬黃祖
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('dock'); m.unmark('dock');
        for (const u of [V.dx, ...V.b.crew]) if (u.alive && u !== V.dx) m.join(u, me);
        V.gn = ally(w, 'ganning', me.x - 100, me.y + 60, LV);
        m.after(1.5, () => m.line('甘寧', '黃祖營裡的虛實，甘寧一清二楚。跟我來！'));
        V.zu = boss(w, PEOPLE.huangzu, ZU[0], ZU[1], { hp: 2600, atk: 40, armor: 6, name: '黃祖', ms: 175 });
        V.guard = m.camp(ZU[0], ZU[1], [['huangjin', 7], ['bandit', 1]], 280).map((u) => Object.assign(u, { spec: TROOPS.huangzu, name: '黃祖兵' }));
        m.mark('zu', ZU[0], ZU[1], '黃祖', false, V.zu);
        m.obj('zu', '追斬黃祖');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, zu = V.zu;
        if (!zu.alive) { V.caught = true; return true; }
        // 黃祖：孫吳的兵逼近就往東北逃
        if (!V.flee && SG.gd(me.x, me.y, zu.x, zu.y) < 650) { V.flee = true; m.line('黃祖', '擋住他們！我先走！'); }
        if (V.flee) { zu.home = EXIT.slice(); if (SG.gd(zu.x, zu.y, me.x, me.y) > 160) { zu.target = null; zu.think = 0.4; } }
        if (V.flee && SG.gd(zu.x, zu.y, EXIT[0], EXIT[1]) < 140) { vanish(w, zu); return true; }
        return false;
      },
    },
    { // 4. 梟首
      enter(m, w) {
        const V = m.vars;
        m.done('zu'); m.unmark('zu');
        rout(m, w, V.guard, EXIT);
        m.card(V.caught ? '祖挺身亡走，追梟其首。' : '祖挺身亡走，騎士馮則追梟其首。', '《吳主傳》');
        m.after(3, () => m.line('孫權', '父仇得報！'));
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('凌統陣亡'); return; }
    const V = m.vars;
    if (V.dx && !V.dx.boat) allyTick(w, V.dx, w.player);
    if (V.gn) allyTick(w, V.gn, w.player);
  },
};
